
import { currencyTypes } from "../../constants/options/currencyTypes";


export function getCurrencyDesc(type){
    
    if ((type + "") == "0") {
        return "TRY";
    }

    var index = currencyTypes.findIndex(w=>w.value == type);
    return currencyTypes[index].label;

}